"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiChartBar, PiCpu, PiShieldCheck } from "react-icons/pi";

export default function SaasFeatures({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const features = content.features || [
    { title: "Analytics", description: "Real-time insights into your data with custom filters.", icon: "chart" },
    { title: "Automation", description: "Save time with powerful AI workflows and triggers.", icon: "cpu" },
    { title: "Security", description: "Enterprise-grade protection keeping details safe.", icon: "security" }
  ];

  const iconMap: Record<string, any> = {
    chart: <PiChartBar className="w-6 h-6 text-blue-400" />,
    cpu: <PiCpu className="w-6 h-6 text-blue-400" />,
    security: <PiShieldCheck className="w-6 h-6 text-blue-400" />,
  };

  return (
    <section
      className={`py-24 px-6 bg-slate-900 text-white transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="text-center space-y-4 max-w-xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight">
            <EditableText
              value={content.title || "Everything you need"}
              onChange={(val) => onContentChange?.({ ...content, title: val })}
              as="span"
            />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feat: any, idx: number) => (
            <div key={idx} className="bg-slate-950 p-8 rounded-2xl border border-slate-800 space-y-4 hover:border-slate-700 transition-all">
              <div className="w-12 h-12 rounded-xl bg-slate-900 border border-slate-800 flex items-center justify-center">
                {iconMap[feat.icon] || <PiCpu className="w-6 h-6 text-blue-400" />}
              </div>
              <h3 className="text-xl font-bold">{feat.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
